import { IconDefinition } from "./types";

const chevronRight: IconDefinition = {
  iconName: "chevron-right",
  width: 384,
  height: 512,
  svgPathData:
    "M362.4 256l-17 17-200 200-17 17-33.9-33.9 17-17 183-183-183-183-17-17 33.9-33.9 17 17 200 200 17 17z",
  iconType: "fill",
  fontAwesomeName: "chevron-right",
  unicode: 0xf054,
};

export { chevronRight };
